import { UserPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/user_/$userId/')({
  component: UserPage,
})
